import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

const setupAxiosInterceptors = () => {
  axios.interceptors.request.use(async (config) => {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.accessToken?.toString();
      if (token) config.headers.Authorization = `Bearer ${token}`;
    } catch (error) {
      console.error('Failed to get auth token:', error);
    }
    return config;
  });
};

export default setupAxiosInterceptors;
